<template>
  <div>
    <table
      v-if="loading == false"
      class="uk-table uk-table-hover journal-table uk-table-middle uk-table-divider"
    >
      <tr>
        <th class="w-20">Temsilci</th>
        <th>Değişen değer</th>
        <th>Zaman</th>
      </tr>
      <tr :key="journal.created_at" v-for="journal in journals">
        <td class="w-20">{{ $root.getVal(15, journal.agent_id) }}</td>
        <td>
          <ul class="journal-list">
            <li
              :key="jvalues"
              v-for="(jkey, jvalues) in JSON.parse(journal.values)"
            >
              <template v-if="fieldsMap[jvalues]">
                <b>{{ fieldsMap[jvalues].display_name }}</b>
                <template v-if="fieldsMap[jvalues].options">
                  {{ $root.getVal(fieldsMap[jvalues].id, jkey.old) }} >
                  {{ $root.getVal(fieldsMap[jvalues].id, jkey.new) }}
                </template>
                <template v-else> {{ jkey.old }} > {{ jkey.new }} </template>
              </template>
            </li>
          </ul>
        </td>
        <td class="w-40">
          <small>{{ journal.created_at }}</small>
        </td>
      </tr>
    </table>

    <div v-else class="center">
      <vk-spinner ratio="2"></vk-spinner>
    </div>

    <div    v-if="
                    $root.cache.me.department == 'admin' ||
                      $root.cache.me.department == 'sales_manager'
                  " >
    <span @click="getBulkJournal()" class="cursor-pointer primary-button">Toplu güncelleme loglarını göster</span>
  


    <table
      v-if="loading == false"
      class="uk-table uk-table-hover journal-table uk-table-middle uk-table-divider"
    >
      <tr>
        <th class="w-20">İŞLEMİ YAPAN KULLANICI</th>
        <th>Değişen değerler</th>
        <th>Zaman</th>
      </tr>
      <tr :key="bjournal.timestamp" v-for="bjournal in bulkJournal">
        <td class="w-20">{{ $root.getVal(15, bjournal.data.userId) }}</td>
        <td>
          <ul class="journal-list">
            <template v-if="(bjournal.data.fieldName == 'agent_id' || bjournal.data.fieldName == 'retention_id')">
             {{ bjournal.data.fieldName }} :   {{ $root.getVal(15, bjournal.data.fieldValue) }} 
            </template>
            <template v-else>
              {{ bjournal.data.fieldName }} : {{ bjournal.data.fieldValue }}
            </template>
            ,
            <template v-if="(bjournal.data.fieldName2 == 'agent_id' || bjournal.data.fieldName2 == 'retention_id')">
              {{ $root.getVal(15, bjournal.data.fieldValue2) }} 
            </template>
            <template v-else>
              {{ bjournal.data.fieldName2 }} : {{ bjournal.data.fieldValue2 }}
            </template>
 
          </ul>    
        </td>
        <td class="w-40">
          <small>{{ bjournal.timestamp}}</small>
        </td>
      </tr>
    </table>

  </div>
  </div>
</template>

<script>
import httpService from "../../../services/http";
export default {
  data() {
    return {
      journals: [],
      bulkJournal: [],
      loading: true
    };
  },
  props: ["id", "fieldsMap"],
  mounted() {
    this.getJournal();
  },
  methods: {
    getJournal() {
      httpService.getJournal("leads", this.id).then(e => {
        this.journals = e.data;
        this.loading = false;
      });
    }, getBulkJournal() {
      this.loading = true;
      httpService.getBulkJournal(this.id).then(e => {
        this.bulkJournal = e.data.data;
        this.loading = false;
      });
    }
  }
};
</script>

<style>
.journal-list li {
  display: block;
}

.journal-table {
  background: #fff;
  border-top: none;
  margin-top: 0px;
}
</style>
